import { Alert } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";

type InvoicesItemDiscardAlertProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onRequestClose: () => void;
};

export const InvoicesItemDiscardAlert = ({
  isOpen,
  onCancel,
  onConfirm,
  onRequestClose,
}: InvoicesItemDiscardAlertProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <Alert
        isOpen={isOpen}
        title={t({
          id: "common.discard-changes-warning-title",
          defaultMessage: "Discard changes?",
        })}
        content={t({
          id: "inventory-item-form-page.discard-changes-description",
          defaultMessage: "If you discard, entered info will not be saved",
        })}
        buttons={[
          {
            text: "Cancel",
            role: "close",
            onClick: onCancel,
          },
          {
            text: "Discard",
            color: "tertiary",
            onClick: onConfirm,
          },
        ]}
        onRequestClose={() => {
          onRequestClose();
        }}
      />
    </div>
  );
};
